import { GridModel, GridPostParams } from "common/models/utility-models/list-utility.model";
import { CompanyMentorModel } from "./company-mentor-data.model";

export class CompanyMentorGridParams extends GridPostParams {
    internshipCompanyId: any = 117;
}
export class CompanyMentorGridModel extends CompanyMentorModel { }

export class CompanyMentorListingModel extends GridModel<CompanyMentorGridModel> { }